import { createRouter, createWebHashHistory } from "vue-router";
import axios from "axios";
import { setUser, clearUser, checkAccess } from "../composables/useCan";
import { resetPageLoading } from "../composables/useBasic";

const routes = [
  {
    path: "/",
    name: "dashboard",
    meta: { title: "Dashboard" },
    children: [
      {
        path: "",
        name: "Main Dashboard",
        meta: { title: "Main Dashboard" },
        component: () => import("../views/Dashboard/Newboard.vue"),
      },
      {
        path: "top-product",
        name: "Top Product",
        meta: { title: "Top Produk" },
        component: () => import("../views/Dashboard/topProduct.vue"),
      },
      {
        path: "critical-sku",
        name: "Critical SKU",
        meta: { title: "SKU Kritis" },
        component: () => import("../views/Dashboard/Critical-Stock.vue"),
      },
      {
        path: "analisa-tier",
        name: "Analisa Tier",
        meta: { title: "Analisa Tier" },
        component: () => import("../views/Analisa/AnalisaTier.vue"),
      },
    ],
  },
  {
    path: "/newboard",
    name: "newboard",
    meta: { title: "Dashboard" },
    component: () => import("../views/Dashboard/Newboard.vue"),
  },
  {
    path: "/inventory",
    name: "Inventory",
    meta: { title: "Master Produk" },
    children: [
      {
        path: "",
        name: "List Inventory",
        meta: { title: "Download & Mapping Produk" },
        component: () => import("../views/Inventory/List-Inventory.vue"),
      },
      {
        path: "get-product",
        name: "Download Inventory",
        meta: { title: "Download Produk" },
        component: () => import("../views/Inventory/Download-Product.vue"),
      },
      {
        path: "connect-product/:id_article",
        name: "Connect Inventory",
        meta: { title: "Koneksi Produk" },
        component: () => import("../views/Inventory/Form-Connecting.vue"),
      },
      {
        path: "list-sync-stock",
        name: "List Sync Stock",
        meta: { title: "Sync Stok" },
        component: () => import("../views/Inventory/List-Sync-Stock.vue"),
      },
      {
        path: "form-sync-stock",
        name: "Form Sync Stock",
        meta: { title: "Form Sync Stok" },
        component: () => import("../views/Inventory/Form-Sync-Stock.vue"),
      },
      {
        path: "status/:id_article",
        name: "Status Product",
        meta: { title: "Status Produk" },
        component: () => import("../views/Inventory/Status-Product.vue"),
      },
      {
        path: "status-koneksi/:id_article",
        name: "Status Koneksi",
        meta: { title: "Status Koneksi Produk" },
        component: () => import("../views/Inventory/Status-Koneksi.vue"),
      },
      {
        path: "updated-product",
        name: "Updated Product",
        meta: { title: "Perubahan Produk E-Commerce" },
        component: () => import("../views/Inventory/Updated-Product.vue"),
      },
    ],
  },
  {
    path: "/update-price",
    name: "Update Price",
    meta: { title: "Update Harga Massal" },
    children: [
      {
        path: "",
        name: "List Update Price",
        meta: { title: "Riwayat Update Harga", access: ["ADMINISTRATOR"] },
        component: () => import("../views/UpdatePrice/List-Update-Price.vue"),
      },
      {
        path: "form",
        name: "Form Update Price",
        meta: { title: "Buat Update Harga", access: ["ADMINISTRATOR"] },
        component: () => import("../views/UpdatePrice/Form-Update-Price.vue"),
      },
      {
        path: "detail/:id",
        name: "Detail Update Price",
        meta: { title: "Detail Update Harga", access: ["ADMINISTRATOR"] },
        component: () => import("../views/UpdatePrice/Detail-Update-Price.vue"),
      },
      {
        path: "live",
        name: "Live Prices",
        meta: { title: "Cek Harga Live", access: ["ADMINISTRATOR"] },
        component: () => import("../views/UpdatePrice/Live-Prices.vue"),
      },
    ],
  },
  {
    path: "/discount",
    name: "Discount",
    meta: { title: "Daftar Diskon" },
    children: [
      {
        path: "",
        name: "List Discount",
        meta: { title: "Daftar Diskon", access: ["ADMINISTRATOR"] },
        component: () => import("../views/Discount/List-Discount.vue"),
      },
      {
        path: "detail/:id",
        name: "Detail Discount",
        meta: { title: "Detail Diskon", access: ["ADMINISTRATOR"] },
        component: () => import("../views/Discount/Detail-Discount.vue"),
      },
    ],
  },
  {
    path: "/report",
    name: "Report List",
    meta: { title: "Laporan Cetak Resi" },
    component: () => import("../views/Receipt/newReport.vue"),
  },
  {
    path: "/scan",
    name: "Scan",
    meta: { title: "Outbound" },
    children: [
      {
        path: "",
        name: "List",
        meta: { title: "List Scan" },
        component: () => import("../views/Scan/ScanListNew.vue"),
      },
      {
        path: "detail",
        name: "Outbound",
        meta: { title: "Scan Barang Keluar" },
        component: () => import("../views/Scan/ScanDetailNew.vue"),
      },
      {
        path: "manual",
        name: "Manual via Excell",
        meta: { title: "Scan Manual via Excell" },
        component: () => import("../views/Scan/ScanDetailManual.vue"),
      },
      {
        path: "retur",
        name: "Retur Keluar",
        meta: { title: "Scan Retur Keluar" },
        component: () => import("../views/Scan/ScanDetailNew.vue"),
      },
      {
        path: "merge",
        name: "another",
        meta: { title: "Merge Scan" },
        component: () => import("../views/Scan/ScanMerge.vue"),
      },
    ],
  },
  {
    path: "/retur",
    name: "Barang Retur",
    meta: { title: "Manajemen Retur" },
    children: [
      {
        path: "",
        name: "List Retur",
        meta: { title: "Daftar Retur" },
        component: () => import("../views/Retur/List-Retur.vue"),
      },
      {
        path: "form",
        name: "Form Retur",
        meta: { title: "Tambah Retur" },
        component: () => import("../views/Retur/Form-Retur.vue"),
      },
      {
        path: "in",
        name: "Barang Retur Masuk",
        meta: { title: "Scan Retur Masuk" },
        component: () => import("../views/Retur/ScanRetur.vue"),
      },
      {
        path: "out",
        name: "Barang Retur Keluar",
        meta: { title: "Scan Retur Keluar" },
        component: () => import("../views/Retur/ScanRetur.vue"),
      },
      {
        path: "in-excell",
        name: "Barang Retur Masuk Excell",
        meta: { title: "Scan Retur Masuk (Excell)" },
        component: () => import("../views/Retur/ScanReturExcell.vue"),
      },
      {
        path: "out-excell",
        name: "Barang Retur Keluar Excell",
        meta: { title: "Scan Retur Keluar (Excell)" },
        component: () => import("../views/Retur/ScanReturExcell.vue"),
      },
      {
        path: "process",
        name: "Proses Barang Retur",
        meta: { title: "Proses Retur" },
        component: () => import("../views/Retur/ProcessRetur.vue"),
      },
      {
        path: "set-shipment",
        name: "Atur Pengiriman Barang Retur",
        meta: { title: "Atur Pengiriman Retur" },
        component: () => import("../views/Retur/SetShipment.vue"),
      },
    ],
  },
  {
    path: "/loan",
    name: "Loan",
    meta: { title: "Loan" },
    children: [
      {
        path: "",
        name: "Loan List",
        meta: { title: "Shoes On Loan" },
        component: () => import("../views/Loan/Loan.vue"),
      },
      {
        path: "detail",
        name: "Loan Detail",
        meta: { title: "Detail Loan" },
        component: () => import("../views/Loan/LoanDetail.vue"),
      },
    ],
  },
  {
    path: "/outgoing",
    name: "Outgoing",
    meta: { title: "Faktur Barang Keluar" },
    children: [
      {
        path: "",
        name: "Outgoing List",
        meta: { title: "Daftar Faktur Keluar" },
        component: () => import("../views/Outgoing/OutgoingList.vue"),
      },
      {
        path: "form",
        name: "Outgoing Form",
        meta: { title: "Buat Faktur Keluar" },
        component: () => import("../views/Outgoing/OutgoingForm.vue"),
      },
      {
        path: "detail/:id",
        name: "Outgoing Detail",
        meta: { title: "Detail Faktur Keluar" },
        component: () => import("../views/Outgoing/OutgoingDetail.vue"),
      },
      {
        path: "faktur/:id",
        name: "Outgoing Faktur",
        meta: { title: "Cetak Faktur Keluar" },
        component: () => import("../views/Outgoing/OutgoingFaktur.vue"),
      },
    ],
  },
  {
    path: "/internal",
    name: "Internal",
    meta: { title: "Penjualan Internal" },
    children: [
      {
        path: "",
        name: "Internal List",
        meta: { title: "Daftar Penjualan Internal" },
        component: () => import("../views/Internal/InternalList.vue"),
      },
      {
        path: "form/:id?",
        name: "Internal Form",
        meta: { title: "Form Penjualan Internal" },
        component: () => import("../views/Internal/InternalForm.vue"),
      },
      {
        path: "faktur/:id?",
        name: "Internal Faktur",
        meta: { title: "Faktur Penjualan Internal" },
        component: () => import("../views/Internal/InternalFaktur.vue"),
      },
    ],
  },
  {
    path: "/settings",
    name: "Settings",
    meta: { title: "Pengaturan" },
    children: [
      {
        path: "",
        name: "Setting List",
        meta: { title: "Menu Pengaturan" },
        component: () => import("../views/Settings/SettingsMenu.vue"),
      },
      {
        path: "old",
        name: "Setting Old",
        meta: { title: "Pengaturan Lama" },
        component: () => import("../views/Settings/Settings.vue"),
      },
      {
        path: "shipment",
        name: "Manage Shipment",
        meta: { title: "Kelola Ekspedisi" },
        component: () => import("../views/Settings/ManageEkspedisi.vue"),
      },
      {
        path: "color",
        name: "Color List",
        meta: { title: "Daftar Warna" },
        component: () => import("../views/Settings/SettingsColor.vue"),
      },
    ],
  },
  {
    path: "/inbound",
    name: "Inbound",
    meta: { title: "Inbound" },
    children: [
      {
        path: "",
        name: "Inbound List",
        meta: { title: "Daftar Inbound" },
        component: () => import("../views/Inbound/List-Inbound.vue"),
      },
      {
        path: "detail/:id_inbound?",
        name: "Inbound Detail",
        meta: { title: "Detail Inbound" },
        component: () => import("../views/Inbound/Form-Inbound.vue"),
      },
      {
        path: "mapping/:id_inbound?",
        name: "Mapping Inbound",
        meta: { title: "Form Pemetaan Inbound" },
        component: () => import("../views/Inbound/Form-Mapping-Inbound.vue"),
      },
      {
        path: "list-mapping",
        name: "Mapping List",
        meta: { title: "Pemetaan Inbound" },
        component: () => import("../views/Inbound/List-Mapping.vue"),
      },
      {
        path: "mapping/detail/:id_inbound",
        name: "Mapping Detail",
        meta: { title: "Detail Pemetaan" },
        component: () => import("../views/Inbound/Mapping-Detail.vue"),
      },
      {
        path: "mapping/print/:id_inbound",
        name: "Mapping Print",
        meta: { title: "Cetak Pemetaan" },
        component: () => import("../views/Inbound/Mapping-Print.vue"),
      },
    ],
  },
  {
    path: "/stock",
    meta: { title: "Stok" },
    children: [
      {
        path: "",
        name: "List Stok",
        meta: { title: "Stok Produk Gudang" },
        component: () => import("../views/Stok/List-Stok.vue"),
      },
      {
        path: "form",
        name: "Form Penyesuaian",
        meta: { title: "Form Penyesuaian Stok" },
        component: () => import("../views/Stok/Form-Stock.vue"),
      },
      {
        path: "history/:sku",
        name: "Riwayat Stok",
        meta: { title: "Riwayat Stok Produk" },
        component: () => import("../views/Stok/Riwayat-Stok.vue"),
      },
      {
        path: "adjustment",
        name: "Riwayat Penyesuaian Stok",
        meta: { title: "Riwayat Penyesuaian" },
        component: () => import("../views/Stok/List-Adjustment-Stok.vue"),
      },
      {
        path: "adjustment/detail/:id_unix",
        name: "Detail Penyesuaian Stok",
        meta: { title: "Detail Penyesuaian Stok" },
        component: () => import("../views/Stok/Detail-Adjustment-Stok.vue"),
      },
      {
        path: "reminder",
        name: "Pengingat Stok",
        meta: { title: "Stok Artikel Menipis" },
        component: () => import("../views/Stok/Pengingat-Stok.vue"),
      },
      {
        path: "siap-order",
        name: "Stok Siap Order",
        meta: { title: "Stok Siap Order Menipis" },
        component: () => import("../views/Stok/Siap-Order-Stok.vue"),
      },
    ],
  },
  // {
  //   path: "/sinkronisasi",
  //   children: [
  //     {
  //       path: "",
  //       name: "List Sinkronisasi",
  //       component: () => import("../views/Sinkronisasi/List-Sinkronisasi.vue"),
  //     },
  //     {
  //       path: "detail/:id_sinkronisasi",
  //       name: "Detail Sinkronisasi",
  //       component: () =>
  //         import("../views/Sinkronisasi/Detail-Sinkronisasi.vue"),
  //     },
  //   ],
  // },
  // {
  //   path: "/stock-sync",
  //   children: [
  //     {
  //       path: "",
  //       name: "List Map Sync Stock",
  //       component: () => import("../views/Sync-Stock/List-Sync-Stock.vue"),
  //     },
  //     {
  //       path: "form",
  //       name: "Form Sync Stock",
  //       component: () => import("../views/Sync-Stock/Form-Sync-Stock.vue"),
  //     },
  //     {
  //       path: "detail/:id",
  //       name: "Detail Sync Stock",
  //       component: () => import("../views/Sync-Stock/Detail-Sync-Stock.vue"),
  //     },
  //   ],
  // },
  {
    path: "/analisa",
    meta: { title: "Analisa" },
    children: [
      {
        path: "",
        name: "Analisa Stok",
        meta: { title: "Analisa Stok" },
        component: () => import("../views/Analisa/AnalisaStok.vue"),
      },
      {
        path: "poc",
        name: "Analisa POC",
        meta: { title: "Proof of Concept" },
        component: () => import("../views/Analisa/component-poc.vue"),
      },
    ],
  },
  // {
  //   path: "/marketplace",
  //   children: [
  //     {
  //       path: "",
  //       name: "Marketplace Product",
  //       component: () => import("../views/Marketplace/Marketplace-List.vue"),
  //     },
  //     {
  //       path: "form-main",
  //       name: "Marketplace Form",
  //       component: () => import("../views/Marketplace/Marketplace-Product.vue"),
  //     },
  //     {
  //       path: "list-affiliate",
  //       name: "Affiliate Product",
  //       component: () => import("../views/Marketplace/Affiliate-Product.vue"),
  //     },
  //     {
  //       path: "form-affiliate",
  //       name: "Affiliate Form",
  //       component: () => import("../views/Marketplace/Affiliate-Form.vue"),
  //     },
  //   ],
  // },
  {
    path: "/integrasi",
    name: "Integration",
    meta: { title: "Integrasi E-Commerce" },
    component: () => import("../views/Intregrasi/List-Ecommerce.vue"),
  },
  {
    path: "/login",
    name: "Login",
    meta: {
      noAuth: true,
      title: "Login",
    },
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/noaccess",
    meta: {
      noAuth: true,
      title: "No Access",
    },
    component: () => import("@/views/NoAccess"),
  },
  {
    path: "/:pathMatch(.*)*",
    meta: {
      noAuth: true,
      title: "Not Found",
    },
    component: () => import("@/views/NotFound"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  let temp_token = null;
  if (process.env.NODE_ENV == "development") {
    // next();
    // ADMIN
    // temp_token =
    //   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImFkbWluIiwiaWF0IjoxNzA1ODkzODc3LCJleHAiOjE3MDYxNTMwNzd9.-JHH2tzqzVoo5bkx6ROxExs3IBk3z-7knCYEefA_Qjk";
    // warehouse staff
    // temp_token =
    //   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwidXNlcm5hbWUiOiJqYWNvYiIsIm5hbWUiOiJKYWNvYiBKb25lcyIsInJvbGUiOiJXQVJFSE9VU0UiLCJpYXQiOjE3MDM3MzU3NDQsImV4cCI6MTcwNDM0MDU0NH0.D539GrsECMfC2vsGs5uxyRMU4OwgvCXTRg3Zj2VsFi0";
    // shopee admin
    // temp_token =
    //   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6NCwidXNlcm5hbWUiOiJzaG9wZWUiLCJuYW1lIjoiU2hvcGVlIEFkbWluIiwicm9sZSI6IkFETUlOIiwiaWF0IjoxNzAzNzM1NzY0LCJleHAiOjE3MDQzNDA1NjR9.tFEk5X2UKzumKjZ0hr9h9NF76IXiSDvebx41ErHqXKo";
    // GATEKEEPER
    // temp_token =
    //   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6NSwidXNlcm5hbWUiOiJnYXRla2VlcGVyIiwibmFtZSI6IkdBVEVLRUVQRVIiLCJyb2xlIjoiR0FURUtFRVBFUiIsImlhdCI6MTcwMzczNTgyMCwiZXhwIjoxNzA0MzQwNjIwfQ.i8WyaYCp7_DtJLR_28hIkSlK-FganZU-ubz03EWtUGU";
    // localStorage.setItem(process.env.VUE_APP_TOKEN_NAME, temp_token);
  }

  let token = localStorage.getItem(process.env.VUE_APP_TOKEN_NAME);
  // token = null;
  if (to.meta.noAuth) {
    next();
  } else if (token === null) {
    // console.log("no token");
    next("/login");
  } else {
    try {
      let resp = await axios.post(
        `${process.env.VUE_APP_BASE_URL}/user/user_data`,
        {
          token: token,
          route: {
            name: to.name,
            path: to.fullPath,
          },
        },
      );
      to.meta.user = resp.data;
      // suplai user ke useCan supaya directive v-can punya sumber data
      setUser(resp.data);
      if (to.meta?.access == null) {
        next();
      } else {
        let access = checkAccess(resp.data, to.meta.access);
        if (access) {
          next();
        } else {
          next("/noaccess");
        }
      }
    } catch (error) {
      console.log(error);
      console.log("gagal menarik data user");
      clearUser();
      localStorage.removeItem(process.env.VUE_APP_TOKEN_NAME);
      let redirect_url = to.fullPath;
      redirect_url = encodeURIComponent(redirect_url);
      next(`/login?redirect_url=${redirect_url}`);
    }
  }
});

// tiap route berubah, selesaikan loading halaman sebelumnya supaya overlay
// tidak nyangkut saat user pindah menu di tengah loading
router.afterEach(() => {
  resetPageLoading();
});

export default router;
